export default __webpack_public_path__ + "static/media/tn-light-webfont.087c57df.woff";